import { createSmileExpressionFrames } from "../../core/expression-keyframes.js";

export const meta = Object.freeze({
  id: "hop-laugh",
  label: "Hüpfen + Lachen",
  duration: 1900,
  description: "Antizipation, hoher Hüpfer, Lachaugen, Landung und kleiner Rebound.",
  tags: ["body", "expression", "one-shot", "loopable"],
});

export async function run({ elements, animate }) {
  const expression = createSmileExpressionFrames({
    enterStart: .10,
    enterCross: .15,
    enterEnd: .20,
    exitStart: .83,
    exitCross: .86,
    exitEnd: .90,
    settleEnd: .94,
    smileHoldFrames: [
      { opacity: 1, transform: "scale(1, 1) translateY(0)", offset: .78 },
    ],
  });

  const body = animate(elements.actor, [
    { transform: "translateY(0) scale(1, 1) rotate(0deg)", offset: 0 },
    { transform: "translateY(4px) scale(1.09, .91) rotate(0deg)", offset: .10, easing: "cubic-bezier(.5,0,.8,.4)" },
    { transform: "translateY(-17px) scale(.965, 1.055) rotate(-2deg)", offset: .22, easing: "cubic-bezier(.12,.72,.24,1)" },
    { transform: "translateY(-34px) scale(.975, 1.035) rotate(1.5deg)", offset: .34 },
    { transform: "translateY(-30px) scale(.99, 1.02) rotate(2deg)", offset: .43 },
    { transform: "translateY(-12px) scale(1.015, .985) rotate(-1deg)", offset: .56, easing: "cubic-bezier(.5,0,.8,.5)" },
    { transform: "translateY(3px) scale(1.105, .895) rotate(0deg)", offset: .66 },
    { transform: "translateY(-10px) scale(.985, 1.025) rotate(.8deg)", offset: .76, easing: "cubic-bezier(.15,.8,.25,1)" },
    { transform: "translateY(1px) scale(1.035, .97) rotate(-.4deg)", offset: .87 },
    { transform: "translateY(0) scale(1, 1) rotate(0deg)", offset: 1, easing: "cubic-bezier(.16,1,.3,1)" },
  ], { duration: meta.duration, easing: "linear" });

  const shadow = animate(elements.shadow, [
    { transform: "scaleX(1)", opacity: .28, offset: 0 },
    { transform: "scaleX(1.12)", opacity: .34, offset: .10 },
    { transform: "scaleX(.56)", opacity: .13, offset: .34 },
    { transform: "scaleX(.62)", opacity: .15, offset: .43 },
    { transform: "scaleX(1.15)", opacity: .36, offset: .66 },
    { transform: "scaleX(.82)", opacity: .20, offset: .76 },
    { transform: "scaleX(1)", opacity: .28, offset: 1 },
  ], { duration: meta.duration, easing: "ease-in-out" });

  const openEyes = animate(elements.openEyes, expression.openEyes, {
    duration: meta.duration,
    easing: "linear",
  });

  const smileEyes = animate(elements.smileEyes, expression.smileEyes, {
    duration: meta.duration,
    easing: "linear",
  });

  const glow = animate(elements.glow, [
    { opacity: .48, offset: 0 },
    { opacity: .76, offset: .28 },
    { opacity: .68, offset: .72 },
    { opacity: .48, offset: 1 },
  ], { duration: meta.duration, easing: "ease-in-out" });

  await Promise.allSettled([body.finished, shadow.finished, openEyes.finished, smileEyes.finished, glow.finished]);
}
